import { makeStyles } from '@material-ui/core/styles'
const useStyles = makeStyles(
  () => ({
    root: {
      color: '#FFF',
      fontWeight: 'bold',
      letterSpacing: '0px',
      position: 'absolute',
      bottom: '573px',
      left: '148px',
      '@media (min-height: 1400px)': {
        position: 'absolute',
        bottom: '800px',
        left: '230px',
      },
      '@media (max-height: 800px), (max-width: 1400px)': {
        position: 'absolute',
        bottom: '430px',
        left: '120px',
      },
    },
  }),
  { index: 1 },
)

export { useStyles }
